import * as React from 'react';
import { CrosswalkPathProps, CrosswalkSegmentProps } from './types';
import { useKineticMapLiveProjection } from 'components/maps/MapContext/hooks/useKineticMap';

const strokeWidth = 8;

const LineSegment: React.FunctionComponent<CrosswalkSegmentProps> = ({
  coordinates,
  point,
  color,
  disabled,
  lighten,
  id,
  onClick,
  onMouseOut,
  onMouseOver,
}) => {
  const point1 = useKineticMapLiveProjection([...coordinates]);
  const point2 = useKineticMapLiveProjection([...point]);
  const pointerEvents = !disabled && (onClick || onMouseOver || onMouseOut);

  if (!point1 || !point2) {
    return null; // No points to connect as a line
  }

  return (
    <line
      id={id}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      pointerEvents={pointerEvents ? undefined : 'none'}
      stroke={color}
      strokeOpacity={lighten ? 0.7 : 1.0}
      strokeWidth={strokeWidth}
      style={onClick ? { cursor: 'pointer' } : undefined}
      x1={point1.x}
      y1={point1.y}
      x2={point2.x}
      y2={point2.y}
    />
  );
};

const CrosswalkPath: React.FunctionComponent<CrosswalkPathProps> = (props) => {
  const { coordinates } = props;

  return (
    <>
      {/* render a line segment for each set of points in the coordinates array */}
      {/* we're slicing then using the i as `currentIndex - 1`  */}
      {coordinates.slice(1).map((point, i) => {
        const lineProps = {
          ...props,
          coordinates: coordinates[i],
        };

        return <LineSegment {...lineProps} point={point} key={i} />;
      })}
    </>
  );
};

export default CrosswalkPath;
